import { useCart } from './useCart';
import { useCartInitialization } from './useCartInitialization';
import { useCartSubscription } from '@/imports/ui/components/Cart/hooks/useCartSubscription';

/**
 * CartInitializer component that handles cart initialization when the app loads.
 * This component should be placed at the root level of the app to ensure
 * cart state is loaded as soon as the user is authenticated.
 * 
 * IMPORTANT: The cart subscription is initialized here so it persists across
 * route changes. This ensures real-time updates continue working when navigating
 * between pages.
 */
export const CartInitializer: React.FC = () => {
  // The hook handles all the initialization logic
  useCartInitialization();
  
  // Get refreshCart from useCart to pass to subscription
  const { refreshCart } = useCart();
  
  // Initialize cart subscription at the root level so it persists across route changes
  // This ensures the subscription doesn't get stopped/restarted when navigating
  useCartSubscription(refreshCart);

  // This component doesn't render anything - it's just for initialization
  return null;
};